import { css, Theme } from "@emotion/react";

export const hint = (theme: Theme) =>
    css({
        color: theme.candy.typography.inactive.color,

        "&.hover": {
            color: theme.candy.invertedColors.inactiveColor,
        },
    });

export const item = () =>
    css({
        whiteSpace: "normal",
        maxWidth: "300px",

        "&.no-wrap": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
    });

export const total = () =>
    css({
        maxWidth: "300px",
    });

export const container = () =>
    css({
        display: "flex",
    });

export const name = () =>
    css({
        flex: 1,
    });
